
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Control } from '@/__env/lib/Expedicion/Control';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public Seleccionado: number = 0;
        public get SeleccionadoReal()
        {
            return this.Items.findIndex( x => x.Id == this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Id );
        };
        public Cargando: string = 'ninguno';

        public get Items()
        {
            let ii: { Id?: string, Tipo: 'opcion' | 'titulo'; Icono?: string; Titulo?: string; Accion?: Function; Desactivado?: boolean; }[] = [];

            ii.push( { Tipo: 'titulo', Titulo: 'Pedido' } );

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Id: "items", Tipo: 'opcion', Icono: 'package-variant-closed', Titulo: 'Agregar/Editar items', Accion: this.VolverALosItems } );
            }

            ii.push( { Id: "nuevo", Tipo: 'opcion', Icono: 'cart-plus', Titulo: 'Nuevo', Accion: this.Nuevo } );
            ii.push( { Id: "abrir", Tipo: 'opcion', Icono: 'folder-open', Titulo: 'Abrir', Accion: this.Abrir } );

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Id: "guardar", Tipo: 'opcion', Icono: 'content-save', Titulo: 'Guardar', Accion: this.Guardar } );
                if ( this.Controlador.Pedido && this.Controlador.Pedido.Existe )
                {
                    ii.push( { Id: "eliminar", Tipo: 'opcion', Icono: 'trash-can', Titulo: 'Eliminar el pedido', Accion: this.Eliminar } );
                }

                ii.push( { Id: "finalizar", Tipo: 'opcion', Icono: 'send', Titulo: 'Finalizar', Accion: this.Finalizar } );




            }

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Tipo: 'titulo', Titulo: 'Archivos' } );
                ii.push( { Id: "nota_venta", Tipo: 'opcion', Icono: 'receipt', Titulo: 'Descargar nota de venta', Accion: this.DescargarNotaDeVenta } );
                ii.push( { Id: "ticket_venta", Tipo: 'opcion', Icono: 'receipt', Titulo: 'Imprimir ticket de venta', Accion: this.DescargarTicket } );
                ii.push( { Id: "presupuesto", Tipo: 'opcion', Icono: 'file-document', Titulo: 'Descargar presupuesto', Accion: this.DescargarPresupuesto } );
                ii.push( { Id: "zebra", Tipo: 'opcion', Icono: 'barcode', Titulo: 'Etiquetas Zebra', Accion: this.ImprimirEtiquetas } );
            }

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Tipo: 'titulo', Titulo: 'Cliente' } );
                ii.push( { Id: "cliente", Tipo: 'opcion', Icono: 'account-convert', Titulo: 'Cambiar cliente', Accion: this.CambiarCliente } );
                ii.push( { Id: "editar_cliente", Tipo: 'opcion', Icono: 'account-edit', Titulo: 'Editar cliente', Accion: this.EditarCliente } );
            }
            else if ( this.Controlador.EdicionPedido.Vendedor && this.Controlador.EdicionPedido.Vendedor.Existe )
            {
                ii.push( { Tipo: 'titulo', Titulo: 'Cliente' } );
                ii.push( { Id: "cliente", Tipo: 'opcion', Icono: 'account-convert', Titulo: 'Agregar cliente', Accion: this.CambiarCliente } );
                ii.push( { Id: "cliente", Tipo: 'opcion', Icono: 'account-convert', Titulo: 'Crear cliente', Accion: this.CrearCliente } );
            }

            if ( this.Controlador.EdicionPedido.Tipo && !this.Controlador.EdicionPedido.Tipo.esNoEspecificado )
            {
                ii.push( { Tipo: 'titulo', Titulo: 'Vendedor' } );
                ii.push( { Id: "vendedor", Tipo: 'opcion', Icono: 'face-agent', Titulo: 'Cambiar vendedor', Accion: this.CambiarVendedor } );
            }

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Tipo: 'titulo', Titulo: 'Envío' } );
                ii.push( { Id: "envio", Tipo: 'opcion', Icono: 'truck', Titulo: 'Agregar/Editar envío', Accion: this.EditarEnvio } );
            }

            ii.push( { Tipo: 'titulo', Titulo: 'Más' } );
            if ( this.Controlador.Pedido && this.Controlador.Pedido.Existe )
                ii.push( { Id: "ir-al-detalle", Tipo: 'opcion', Icono: 'open-in-new', Titulo: 'Ir al detalle', Accion: this.IrAlDetalle } );
            ii.push( { Id: "ir-al-listado", Tipo: 'opcion', Icono: 'format-list-checkbox', Titulo: 'Ir al listado', Accion: this.IrAlListado } );
            ii.push( { Id: "configuracion", Tipo: 'opcion', Icono: 'settings', Titulo: 'Configuración', Accion: this.Configuracion } );
            ii.push( { Id: "salir", Tipo: 'opcion', Icono: 'exit-run', Titulo: 'Salir', Accion: this.Salir } );

            return ii;
        }

        VolverALosItems()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
        }
        Nuevo()
        {
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                this.Controlador.Vista.BarraIzquierda.SubModo = 'nuevo';
                this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';

            } else
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'nuevo';
            }
        }
        Abrir()
        {
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                this.Controlador.Vista.BarraIzquierda.SubModo = 'pedidos';
                this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';

            } else
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'pedidos';
            }
        }

        Guardar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';
        }

        Finalizar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'finalizar';
        }

        Configuracion() { this.Controlador.Vista.BarraIzquierda.Modo = 'configuracion'; }
        async Salir()
        {

            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = '';
                if ( await Utiles.Mensajes.SiNo( 'Salir', '¿Salir del pedido actual sin guardar?' ) )
                {
                    this.$router.push( '/inicio' );
                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
                }
            } else
            {
                this.$router.push( '/inicio' );
            }


        }

        async IrAlListado()
        {
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = '';
                if ( await Utiles.Mensajes.SiNo( 'Salir', '¿Salir del pedido actual sin guardar?' ) )
                {
                    this.$router.push( '/pedidos?tipo=' + this.Controlador.EdicionPedido.Tipo.Id );
                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
                }
            } else
            {
                this.$router.push( '/pedidos?tipo=' + this.Controlador.EdicionPedido.Tipo.Id );
            }


        }

        async IrAlDetalle()
        {
            if ( !this.Controlador.Pedido.Existe )
                return;

            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = '';
                if ( await Utiles.Mensajes.SiNo( 'Salir', '¿Salir del pedido actual sin guardar?' ) )
                {
                    this.$router.push( '/pedido/' + this.Controlador.Pedido.Id );
                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
                }
            } else
            {
                this.$router.push( '/pedido/' + this.Controlador.Pedido.Id );
            }


        }

        Eliminar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'eliminar';
        }

        async DescargarNotaDeVenta( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLNotaDeVenta( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la nota de venta` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';

        }

        async DescargarTicket( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLNotaDeVenta( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la nota de venta` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';
        }

        async DescargarPresupuesto( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLPresupuesto( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar el archivo` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';
        }

        async ImprimirEtiquetas()
        {
            let e = await this.Controlador.Guardar();
            if ( e )
            {
                //let pdf = await Pedido.URLEtiquetasItems( [this.Controlador.Pedido] );
                //if ( pdf )
                //{
                //
                //} else
                //{
                //    Utiles.Notificaciones.Error( `Error al generar la nota de venta` );
                //
                //}
            } else
            {
                Utiles.Notificaciones.Error( `Error al guardar el pedido` );
            }

        }

        CambiarCliente()
        {


            this.Controlador.Vista.BarraIzquierda.Modo = 'clientes';
        }

        CrearCliente()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'editar_cliente';
        }

        EditarCliente()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'editar_cliente';

        }
        CambiarVendedor()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'vendedores';
        }

        EditarEnvio()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'editar_envio';

        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }
        created()
        {
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        onKeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'Tab', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( this.Cargando != 'ninguno' ) return;

            if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'PageUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Items.filter( x => x.Tipo == 'opcion' ).length - 1 );
            }
            else if ( e.key == 'Escape' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado] )
                {
                    this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Accion( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Id );
                }
            }
        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items.filter( x => x.Tipo == 'opcion' )[x] )
            {
                this.Seleccionado = x;
                //console.log( this.Seleccionado, this.isVisibleLista( this.Seleccionado )  );
                //if ( !this.isVisibleLista( this.Seleccionado ) )
                this.ScrollToItemLista();
            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 150,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            console.log( elTop, el.height(), elBottom, winBottom );
            return ( elBottom <= winBottom );
        }
        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
        }


    }
